module.exports = __webpack_public_path__ + "img/romanizer.14c653ba.png";